<script>
import CommonDetail from '@/views/Information/CommonDetail'
import api from '@/utils/api/operation'
export default {
  name: 'WorkGuideDetail',
  extends: CommonDetail,
  data() {
    return {}
  },
  methods: {
    onload() {
      let params = {
        id: this.rid
      }
      api.getWorkGuideDetail(params).then(res => {
        let data = res.data
        this.title = data.BT
        this.date = data.FBSJ
        this.content = data.BSZN
        this.fileList = data.FJ
      })
    }
  }
}
</script>
